import { StepIndicator } from 'foundations-components/transitional/components/StepIndicator';
import { jsx as _jsx } from "react/jsx-runtime";
export default function CreateStepIndicator({
  stepIndex,
  steps
}) {
  let effectiveStepIndex = stepIndex;
  // Some steps share the same label, we should not show duplicate steps in the indicator
  const uniqueStepLabels = new Set();
  steps.forEach(({
    getLabel
  }, index) => {
    const label = getLabel();
    if (uniqueStepLabels.has(label) && index <= effectiveStepIndex) {
      effectiveStepIndex--;
    } else {
      uniqueStepLabels.add(label);
    }
  });
  return /*#__PURE__*/_jsx(StepIndicator, {
    stepIndex: effectiveStepIndex,
    stepNames: Array.from(uniqueStepLabels),
    inlineSize: "100%",
    responsiveBreakpoint: 0,
    marginBlockEnd: "600"
  });
}